module Meevo.Components.Common {

    export class PrintService implements IPrintService {

        private configuredPrintService: IPrintService;
        protected printServices: any;

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private commonPrintService: Meevo.Components.Common.IPrintService,
            private jcpPrintService: Meevo.Components.Common.IPrintService,
            private $q: angular.IQService
        ) {
            this.printServices = {
                "meevo.components.common.CommonPrintService": commonPrintService,
                "meevo.components.common.JcpPrintService": jcpPrintService
            };
        }

        /* Getter and Setter */
        getPrinterList(): angular.IPromise<IPrintServicePrinter[]> {
            return this.getConfiguredPrintService()
                .then(printService => printService.getPrinterList() );
        }

        getSelectedPrinter(): angular.IPromise<IPrintServicePrinter> {
            return this.getConfiguredPrintService()
                .then(printService => printService.getSelectedPrinter() );
        }

        setSelectedPrinter(printer: IPrintServicePrinter): angular.IPromise<void> {
            return this.getConfiguredPrintService()
                .then(printService => printService.setSelectedPrinter(printer) );
        }

        setSelectedTerminal(terminal: Meevo.Model.MerchantTerminal): angular.IPromise<void> {
            return this.getConfiguredPrintService()
                .then(printService => printService.setSelectedTerminal(terminal) );
        }

        /* Print methods */
        print(...documentUrls: string[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.print(...documentUrls) );
        }

        printToDevice(printerDetail: IPrintServicePrinter, ...documentUrls: string[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.printToDevice(printerDetail, ...documentUrls) );
        }

        printCustom(...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.printCustom(...requestObjs) );
        }

        printCustomToDevice(printerDetail: IPrintServicePrinter, ...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.printCustomToDevice(printerDetail, ...requestObjs) );
        }


        private getConfiguredPrintService(): angular.IPromise<IPrintService> {
            if (this.configuredPrintService) {
                return this.$q.resolve(this.configuredPrintService);
            }

            return this.dataService.customMethodData("api/Settings/General", "GET", null)
                .then(response => {
                    var printServiceName: string = response.data.printServiceModule;
                    this.configuredPrintService = this.printServices[printServiceName] || this.printServices[0];
                    return this.configuredPrintService;
                });
        }

        /* Pole Display methods */
        showStandbyMessage() {
            return this.getConfiguredPrintService()
                .then(printService => printService.showStandbyMessage());
        }

        queueMessagesToPoleDisplay(lockCallback?: () => angular.IPromise<boolean>, ...messages: IPoleDisplayObject[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.queueMessagesToPoleDisplay(lockCallback, ...messages));
        }

        queueMessagesToPoleDisplayToDevice(printerDetail: IPrintServicePrinter, lockCallback?: () => angular.IPromise<boolean>, ...messages: IPoleDisplayObject[]): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.queueMessagesToPoleDisplayToDevice(printerDetail, lockCallback, ...messages));
        }

        resetPoleDisplay(printerDetail?: IPrintServicePrinter): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.resetPoleDisplay(printerDetail));
        }

        /* Drawer method */
        openDrawer(printerDetail?: IPrintServicePrinter): angular.IPromise<any> {
            return this.getConfiguredPrintService()
                .then(printService => printService.openDrawer(printerDetail));
        }

        static factory(): Function {
            const svc = (
	            dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                commonPrintService: Meevo.Components.Common.IPrintService,
                jcpPrintService: Meevo.Components.Common.IPrintService,
                $q: angular.IQService
            ) => new PrintService(
				dataService,
				modalService,
				commonPrintService,
				jcpPrintService,
				$q
			);

            svc.$inject = [
                "meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                "meevo.components.common.CommonPrintService",
                "meevo.components.common.JcpPrintService",
                "$q"
            ];

            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.PrintService", PrintService.factory());
}